import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import config from "../../../config";
import { showToast } from "../../../utils/toast";

export default function CategoryModal({ show, onClose, refresh, editData }) {
  const [formData, setFormData] = useState({
    category_name: "",
    description: ""
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        category_name: editData.category_name,
        description: editData.description || ""
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.category_name.trim()) {
      showToast("warning", "Category name is required");
      return;
    }

    try {
      let res;

      if (editData) {
        res = await axios.put(
          `${config.apiBaseUrl}/inventory/update-category.php`,
          {
            ...formData,
            category_id: editData.category_id
          }
        );
      } else {
        res = await axios.post(
          `${config.apiBaseUrl}/inventory/create-category.php`,
          formData
        );
      }

      if (res.data.success) {
        showToast("success", res.data.message);
        refresh();
        onClose();
      }

    } catch (error) {
      showToast("error", "Operation failed");
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {editData ? "Edit Category" : "Add Category"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              type="text"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {editData ? "Update" : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}